
















import { Component, Vue } from "vue-property-decorator";
import { mapGetters } from "vuex";
import { IDelegate } from "@/interfaces";

@Component({
  computed: {
    ...mapGetters("delegates", ["delegates"]),
  },
})
export default class DelegateCount extends Vue {
  private count = 0;
  private delegates: IDelegate[];

  public mounted() {
    this.prepareComponent();
  }

  private prepareComponent() {
    this.getDelegateCount();

    this.$store.watch(
      (state) => state.delegates.delegates,
      (value) => this.getDelegateCount(),
    );
  }

  private getDelegateCount() {
    this.count = this.delegates.length;
  }
}
